import React from 'react';
import { FaRocket, FaHandshake, FaLock, FaChartLine } from 'react-icons/fa';

function WhyUs() {
  return (
    <section id="why-us" className="py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Por que nos escolher?</h2>
          <p className="text-muted">Descubra como podemos transformar seu negócio com inovação, segurança e resultados concretos.</p>
        </div>

        <div className="row g-4">
          <div className="col-md-3">
            <div className="card h-100 shadow-sm text-center p-4 border-0">
              <div className="mb-3">
                <FaRocket className="fs-1 text-primary" />
              </div>
              <h5 className="fw-semibold">Inovação e Tecnologia</h5>
              <p className="text-muted">Soluções modernas com tecnologias de ponta para acelerar o crescimento do seu negócio.</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card h-100 shadow-sm text-center p-4 border-0">
              <div className="mb-3">
                <FaHandshake className="fs-1 text-success" />
              </div>
              <h5 className="fw-semibold">Compromisso com o Cliente</h5>
              <p className="text-muted">Parcerias de confiança, sempre focadas nas suas necessidades.</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card h-100 shadow-sm text-center p-4 border-0">
              <div className="mb-3">
                <FaLock className="fs-1 text-danger" />
              </div>
              <h5 className="fw-semibold">Segurança Garantida</h5>
              <p className="text-muted">Proteção completa para suas informações e processos.</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card h-100 shadow-sm text-center p-4 border-0">
              <div className="mb-3">
                <FaChartLine className="fs-1 text-warning" />
              </div>
              <h5 className="fw-semibold">Resultados Mensuráveis</h5>
              <p className="text-muted">Acompanhamento constante de performance com métricas claras.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
